'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        paddingBottom: {
            type: Number,
            default: undefined,
            kComposite: 'padding.bottom'
        },
        paddingLeft: {
            type: Number,
            default: undefined,
            kComposite: 'padding.left'
        },
        paddingRight: {
            type: Number,
            default: undefined,
            kComposite: 'padding.right'
        },
        paddingTop: {
            type: Number,
            default: undefined,
            kComposite: 'padding.top'
        }
    }
};